import { ChangeDetectionStrategy, Component, forwardRef, inject, OnInit } from '@angular/core';
import { EXAMINATION_NAVIGATION_CONFIG } from '@modules/examination/services/examination-navigation.service';
import { TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { ExaminationsService } from '../../services/examinations.service';
import { ExaminationContentComponent } from '../examination-content/examination-content.component';

type Input = {
  patientId: number;
  departmentId?: number;
  clientCode: string;
  examinationId: number;
  examinationFormId: number;
};

@Component({
  selector: 'pxc-examination-dialog',
  imports: [forwardRef(() => ExaminationContentComponent)],
  providers: [
    ExaminationsService,
    {
      provide: EXAMINATION_NAVIGATION_CONFIG,
      deps: [ExaminationDialogComponent],
      useFactory: (component: ExaminationDialogComponent): { examinationFormId: number; examinationId?: number } => ({
        examinationFormId: component.examinationFormId,
        examinationId: component.examinationId,
      }),
    },
  ],
  templateUrl: './examination-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationDialogComponent implements OnInit {
  readonly context = inject<TuiDialogContext<void, Input>>(POLYMORPHEUS_CONTEXT);

  readonly clientCode = this.context.data.clientCode;
  readonly patientId = this.context.data.patientId;
  readonly departmentId = this.context.data.departmentId;
  readonly examinationId = this.context.data.examinationId;
  readonly examinationFormId = this.context.data.examinationFormId;

  private readonly examinationsService = inject(ExaminationsService);

  ngOnInit(): void {
    this.examinationsService.init({
      departmentId: this.departmentId,
      clientCode: this.clientCode,
      patientId: this.patientId,
      fetch: false,
    });
  }
}
